import { combineReducers } from '@reduxjs/toolkit';
import api from '../api/api';

// reducers
import exchangeDictionariesReducer from './dictionaries/slices';

// MARGINS
import marginListReducer from '../hoc/margins/store/slices/list';
import sidepanelMarginReducer from '../hoc/margins/store/slices/sidepanel';
// RATES
import rateListReducer from '../hoc/rates/store/slices/list';
import rateSidepanelReducer from '../hoc/rates/store/slices/sidepanel';

// AUTO SETTINGS
import autoSettingsListReducer from '../hoc/auto-settings/store/slices/list';
import autoSettingsDetilsReducer from '../hoc/auto-settings/store/slices/sidepanel';

// RATE REQUEST
import rateRequestListReducer from '../hoc/rate-request/store/slices/list';
import rateRequestDetailsReducer from '../hoc/rate-request/store/slices/sidepanel';

export const exchangeReducers = {
  exchangeApi: api.reducer,
  exchangeDictionaries: exchangeDictionariesReducer,
  margins: combineReducers({
    list: marginListReducer,
    sidepanel: sidepanelMarginReducer,
  }),
  rates: combineReducers({
    list: rateListReducer,
    sidepanel: rateSidepanelReducer,
  }),
  autoSettings: combineReducers({
    list: autoSettingsListReducer,
    details: autoSettingsDetilsReducer,
  }),
  rateRequest: combineReducers({
    list: rateRequestListReducer,
    sidepanel: rateRequestDetailsReducer,
  }),
};

export const exchangeApi = api;
